/**
 * Loader — spinner or skeleton placeholder for loading states.
 */

import { Box, CircularProgress, Skeleton, Stack } from "@mui/material";

interface LoaderProps {
  /** "spinner" = centered spinner, "skeleton" = content placeholder */
  variant?: "spinner" | "skeleton";
  /** Number of skeleton rows */
  rows?: number;
  /** Full-page centered spinner? */
  fullPage?: boolean;
}

export default function Loader({
  variant = "spinner",
  rows = 5,
  fullPage = false,
}: LoaderProps) {
  if (variant === "skeleton") {
    return (
      <Stack spacing={1.5} sx={{ width: "100%" }}>
        <Skeleton variant="rectangular" height={40} />
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={48} />
        ))}
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...(fullPage ? { minHeight: "60vh" } : { py: 6 }),
      }}
    >
      <CircularProgress />
    </Box>
  );
}
